export default __webpack_public_path__ + "static/media/ponto_1.2ccf08c9.svg";